import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.65 9.5a8.47 8.47 0 11-8.47-8.47" stroke="#fff" strokeWidth="2" strokeLinecap="round" /><path d="M10.69 9.99L7.51 6.8a.92.92 0 00-1.3 1.3l3.07 3.06a2 2 0 002.82 0l8.96-8.96a.92.92 0 10-1.3-1.3L10.7 10z" fill="#fff" /></svg>);